/**
 * Fire-and-forget POST to the Nexus account-signup automation webhook.
 * Same mechanism as website lead forms → automation-webhook/{wh_…}.
 * Must never block or fail signup.
 */

const DEFAULT_WEBHOOK_URL =
  'https://idvgoctfaarxiryxprpy.supabase.co/functions/v1/automation-webhook/wh_z7lr60g0bjkmrtpng0l';

export type SignupWebhookPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone?: string | null;
  business_name: string;
  business_email?: string | null;
  business_address?: string | null;
  business_id: string;
  source?: string;
  referral_partner_code?: string | null;
  signup_flow?: string | null;
  qualifying_answers?: Record<string, unknown> | null;
};

export function notifySignupAutomationWebhook(payload: SignupWebhookPayload): void {
  const url =
    (import.meta.env.VITE_SIGNUP_AUTOMATION_WEBHOOK_URL as string | undefined)?.trim() ||
    DEFAULT_WEBHOOK_URL;

  const body = {
    first_name: payload.first_name?.trim() || '',
    last_name: payload.last_name?.trim() || '',
    name: [payload.first_name, payload.last_name].filter(Boolean).join(' ').trim(),
    email: payload.email?.trim().toLowerCase() || '',
    phone: payload.phone?.trim() || '',
    business_name: payload.business_name?.trim() || '',
    business_email: payload.business_email?.trim() || '',
    business_address: payload.business_address?.trim() || '',
    business_id: payload.business_id,
    source: payload.source || 'account_signup',
    referral_partner_code: payload.referral_partner_code || '',
    signup_flow: payload.signup_flow || '',
    ...(payload.qualifying_answers ? { qualifying_answers: payload.qualifying_answers } : {}),
  };

  void fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        console.warn('[signup-webhook] non-OK response:', res.status, text);
      }
    })
    .catch((err) => {
      console.warn('[signup-webhook] failed (non-critical):', err);
    });
}
